import { CoinAmount } from '@/types'

export function coinAmountFromBalances(
  balances: CoinAmount[] | undefined,
  denom: string,
): string {
  if (!balances || balances.length === 0) return '0'
  const coin = balances.find(b => b.denom === denom)
  return coin?.amount ?? '0'
}

export function computeDelegationState(
  haveAtomic: string,
  minimalDelegationAmount: string,
) {
  let remainingAtomic = '0'
  let hasEnoughDelegation = false
  let remainingColorClass = 'text-yellow-400'

  try {
    const need = BigInt(minimalDelegationAmount)
    const have = BigInt(haveAtomic)

    if (need > have) remainingAtomic = (need - have).toString()
    else remainingAtomic = '0'

    hasEnoughDelegation = have >= need

    if (hasEnoughDelegation) remainingColorClass = 'text-[#16D1D6]'
    else remainingColorClass = have > 0n ? 'text-yellow-400' : 'text-red-400'
  } catch {
    // keep defaults
  }

  return { remainingAtomic, hasEnoughDelegation, remainingColorClass }
}
